import { render, staticRenderFns } from "./LendableBooks.vue?vue&type=template&id=1f669d22&"
import script from "./LendableBooks.vue?vue&type=script&lang=js&"
export * from "./LendableBooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports